import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface DuplicateDataSourceDialogProps {
  open: boolean;
  sourceName: string;
  duplicateName: string;
  isSubmitting: boolean;
  onDuplicateNameChange: (value: string) => void;
  onConfirm: () => void;
  onClose: () => void;
}

export default function DuplicateDataSourceDialog({
  open,
  sourceName,
  duplicateName,
  isSubmitting,
  onDuplicateNameChange,
  onConfirm,
  onClose,
}: DuplicateDataSourceDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => (!nextOpen ? onClose() : undefined)}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Duplicate Data Source</DialogTitle>
          <DialogDescription>
            Create a copy of <span className="font-medium">{sourceName}</span> with a new name.
          </DialogDescription>
        </DialogHeader>

        <form
          className="space-y-4"
          onSubmit={(event) => {
            event.preventDefault();
            onConfirm();
          }}
        >
          <div className="space-y-2">
            <Label htmlFor="duplicate-name">Duplicate Name</Label>
            <Input
              id="duplicate-name"
              value={duplicateName}
              onChange={(event) => onDuplicateNameChange(event.target.value)}
              placeholder={`${sourceName} (Copy)`}
              autoFocus
            />
            <p className="text-xs text-muted-foreground">
              Draft name stays while this tab session is active.
            </p>
          </div>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Duplicating...
                </>
              ) : (
                'Duplicate'
              )}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
